import { prop } from 'ramda';
import { makeModuleAsync } from '@/utils';
import { getUsers as endpoint } from '@/config/endpoints';

const parseApiResponse = prop('users');

export default makeModuleAsync({ endpoint, parseApiResponse });
